'use client';

import styled from 'styled-components';

export const StyledSimpleCalloutCards = styled.div`
  padding-top: ${props => props.theme.spacing(16)};
  padding-bottom: ${props => props.theme.spacing(16)};
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  span {
    color: ${props => props.theme.colors.get(props.$fontColor)};
  }
`;

export const HeadlineWrapper = styled.div`
  margin: ${props => props.theme.spacing(0, 3, 6)};
  max-width: 1024px;
  span {
    color: ${props => props.theme.colors.get(props.$fontColor)};
  }

  @media ${props => props.theme.tablet} {
    margin: auto;
    margin-bottom: ${props => props.theme.spacing(6)};
  }
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.mobileCardsPerRow}, 1fr);
  justify-items: center;
  padding-left: calc(
    ${props => props.theme.spacing(6)} / ${props => props.mobileCardsPerRow}
  );
  padding-right: calc(
    ${props => props.theme.spacing(6)} / ${props => props.mobileCardsPerRow}
  );
  gap: calc(
    ${props => props.theme.spacing(6)} / ${props => props.mobileCardsPerRow}
  );
  @media ${props => props.theme.tablet} {
    display: grid;
    grid-template-columns: repeat(${props => props.desktopCardsPerRow}, 1fr);
    grid-gap: calc(
      ${props => props.theme.spacing(12)} / ${props => props.desktopCardsPerRow}
    );
    justify-content: center;
    margin: 0
      calc(
        ${props => props.theme.spacing(12)} /
          ${props => props.desktopCardsPerRow}
      );
  }
  @media ${props => props.theme.laptop} {
    padding: 0px;
  }
`;

export const CtaWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(12)};
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  margin-top: ${props => props.theme.spacing(12)};
  width: 110%;
  margin-left: -5%;
`;

export const Subheader = styled.p`
  ${props => props.theme.typography.heading5};
  ${props => props.theme.fontFamily.base}
  text-align: center;
  color: ${props => props.theme.colors.get(props.$fontColor)};
`;
